import { Control } from '../control';
import { View } from '../view';

export namespace Button {
    /**
     * 动作场景类型
     */
    export const enum ButtonSceneType {
        Form = 1,
        List = 2,
    }

    /**
     * 按钮携带参数值类型
     */
    export const enum MappingValueType {
        /** 固定值 */
        Fixed = 1,
        /** 动态值 */
        Property = 2,
    }
    // 自定义参数字段配置属性
    export interface IDynamicControlProperty {
        defaultItems?: string[];
        defaultValue?: string;
        displayFormat?: string;
        decimalPlaces?: number;
        showMode?: Control.NumberShowMode;
        mode: Control.TextMode;
        unitSelectionRange?: string;
        associationSchemaCode?: string;
    }

    // 按钮自定义参数字段
    export interface IDynamicControl {
        key: string;
        dataType: Control.BizDataType;
        controlType: Control.FormControlType;
        displayName: string;
        visible: boolean;
        required: boolean;
        extension: IDynamicControlProperty;
    }

    /** 系统默认列表按钮 */
    export const DefaultListActions = {
        [View.SystemActionKey.Create]: {
            actionCode: 'Create',
            displayName: '新增',
            icon: 'fa-plus',
            isPrintAction: false,
            isCustomPrint: false,
            actionType: View.ActionType.System,
        },
        [View.SystemActionKey.Import]: {
            actionCode: 'Import',
            displayName: '导入',
            icon: 'fa-download',
            isPrintAction: false,
            isCustomPrint: false,
            actionType: View.ActionType.System,
        },
        [View.SystemActionKey.Export]: {
            actionCode: 'Export',
            displayName: '导出',
            icon: 'fa-upload',
            isPrintAction: false,
            isCustomPrint: false,
            actionType: View.ActionType.System,
        },
        [View.SystemActionKey.Remove]: {
            actionCode: 'Remove',
            displayName: '删除',
            icon: 'fa-times',
            isPrintAction: false,
            isCustomPrint: false,
            actionType: View.ActionType.System,
        },
        [View.SystemActionKey.Print]: {
            actionCode: 'Print',
            displayName: '打印',
            icon: 'fa-print',
            isPrintAction: false,
            isCustomPrint: false,
            actionType: View.ActionType.System,
        },
        [View.SystemActionKey.PrintQrCode]: {
            actionCode: 'PrintQrCode',
            displayName: '打印二维码',
            icon: 'fa-qrcode',
            isPrintAction: false,
            isCustomPrint: false,
            actionType: View.ActionType.System,
        },
    };

    /** 系统默认列表打印按钮 */
    export const DefaultPrintAction: View.IAction = {
        actionCode: 'Print',
        displayName: '打印',
        icon: 'fa-print',
        isPrintAction: false,
        isCustomPrint: false,
    };

    export namespace Request {
        // 批量编辑请求参数
        export interface IBatchUpdateRequestParams {
            schemaCode: string;
            actionCode: string;
            actionName: string;
            bizObjectIds: string[];
            bizData: Record<string, unknown>;
            appendOpFields: string[];
            viewPageId?: string;
        }
    }

    export namespace Response {
        // 批量编辑返回类型
        export interface IBatchUpdateResponse {
            taskId: string;
            logTime: string;
        }

        export type IControlPermission = {
            visible: boolean;
            editable: boolean;
            required: boolean;
            printable: boolean;
        };
    }
}
